/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '@angular/common';
import * as import2 from '../../ui-elements/image/image-cache.directive';
import * as import3 from '../../ui-elements/image/cached-image.service';
import * as import4 from '../../buttons/icon-button/icon-button.component.ngfactory';
import * as import5 from '../../buttons/icon-button/icon-button.component';
import * as import6 from '../../orchestration/responsive.directive';
import * as import7 from '../../orchestration/responsive.service';
import * as import8 from '../../orchestration/navigation.service';
import * as import9 from './menu-category-selection-panel.component';
import * as import10 from '../menu.model';
const styles_MenuCategorySelectionPanelComponent:any[] = ([] as any[]);
export const RenderType_MenuCategorySelectionPanelComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_MenuCategorySelectionPanelComponent,
  data: {}
}
);
function View_MenuCategorySelectionPanelComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),6,'div',[[
        'class',
        'menu-category-image'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import1.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod([
      'empty',
      'selected'
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'img',[[
        'class',
        'menu-category-image-object'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import2.ImageCacheDirective,[
      import0.ElementRef,
      import0.Renderer2,
      import3.CachedImageService
    ]
      ,{imageData: [
        0,
        'imageData'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'menu-category-image';
    const currVal_1:any = ck(v,2,0,!co.menuModel.getCategoryImage((<any>v.parent).context.$implicit),(co.menuModel.selectedCategory === (<any>v.parent).context.$implicit));
    ck(v,1,0,currVal_0,currVal_1);
    const currVal_2:any = co.menuModel.getCategoryImage((<any>v.parent).context.$implicit);
    ck(v,5,0,currVal_2);
  },(null as any));
}
function View_MenuCategorySelectionPanelComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-icon-button',[[
        'class',
        'menu-category-title-button'
      ]
    ],[
      [
        1,
        'type',
        0
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'unavailable',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.selectCategory((<any>v.parent).context.$implicit)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import4.View_IconButtonComponent_0,import4.RenderType_IconButtonComponent)),
      import0.ɵdid(49152,(null as any),0,import5.IconButtonComponent,([] as any[]),{type: [
        0,
        'type'
      ]
    },{onActivate: 'onActivate'})
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_3:any = co.IconButtonType.FORWARD;
    ck(v,1,0,currVal_3);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).type;
    const currVal_1:any = import0.ɵnov(v,1).disabled;
    const currVal_2:any = import0.ɵnov(v,1).unavailable;
    ck(v,0,0,currVal_0,currVal_1,currVal_2);
  });
}
function View_MenuCategorySelectionPanelComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),20,'div',[
      [
        'class',
        'menu-category'
      ]
      ,
      [
        'woa-responsive',
        ''
      ]

    ]
      ,[[
        8,
        'id',
        0
      ]
      ],[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.selectCategory(v.context.$implicit)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import1.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod([
      'featured',
      'with-image'
    ]
    ),
    import0.ɵdid(737280,(null as any),0,import6.ResponsiveDirective,[
      import0.ElementRef,
      import7.ResponsiveService,
      import8.NavigationService,
      import0.ChangeDetectorRef,
      import0.Renderer2
    ]
    ,(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MenuCategorySelectionPanelComponent_2)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),11,'div',[[
        'class',
        'menu-category-title'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import1.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod([
      'selected',
      'with-image'
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'menu-category-title-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import1.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod(['selected']),
    (l()(),import0.ɵted((null as any),[
      '\n            ',
      '\n        '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MenuCategorySelectionPanelComponent_3)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_1:any = 'menu-category';
    const currVal_2:any = ck(v,2,0,v.context.$implicit.featured,co.menuModel.showCategoryImages);
    ck(v,1,0,currVal_1,currVal_2);
    ck(v,3,0);
    const currVal_3:any = co.menuModel.showCategoryImages;
    ck(v,6,0,currVal_3);
    const currVal_4:any = 'menu-category-title';
    const currVal_5:any = ck(v,10,0,(co.menuModel.selectedCategory === v.context.$implicit),co.menuModel.showCategoryImages);
    ck(v,9,0,currVal_4,currVal_5);
    const currVal_6:any = 'menu-category-title-name';
    const currVal_7:any = ck(v,14,0,(co.menuModel.selectedCategory === v.context.$implicit));
    ck(v,13,0,currVal_6,currVal_7);
    const currVal_9:boolean = (!co.menuModel.showCategoryImages && co.showNavIcons);
    ck(v,18,0,currVal_9);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵinlineInterpolate(1,'category-',v.context.index,'');
    ck(v,0,0,currVal_0);
    const currVal_8:any = co.menuModel.getCategoryDisplayName(v.context.$implicit);
    ck(v,15,0,currVal_8);
  });
}
export function View_MenuCategorySelectionPanelComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(2,[
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MenuCategorySelectionPanelComponent_1)),
    import0.ɵdid(802816,(null as any),0,import1.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import9.MenuCategorySelectionPanelComponent = v.component;
    const currVal_0:any = co.menuModel.selectableCategories;
    ck(v,1,0,currVal_0);
  },(null as any));
}
function View_MenuCategorySelectionPanelComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-menu-category-selection-panel',([] as any[]),[[
        2,
        'with-images',
        (null as any)
      ]
    ],(null as any),(null as any),View_MenuCategorySelectionPanelComponent_0,RenderType_MenuCategorySelectionPanelComponent)),
    import0.ɵdid(180224,(null as any),0,import9.MenuCategorySelectionPanelComponent,[
      import10.MenuModel,
      import0.ChangeDetectorRef
    ]
    ,(null as any),(null as any))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).withImages;
    ck(v,0,0,currVal_0);
  });
}
export const MenuCategorySelectionPanelComponentNgFactory:import0.ComponentFactory<import9.MenuCategorySelectionPanelComponent> = import0.ɵccf('woa-menu-category-selection-panel',import9.MenuCategorySelectionPanelComponent,View_MenuCategorySelectionPanelComponent_Host_0,{showNavIcons: 'showNavIcons'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/menu/menu-category-selection-panel/menu-category-selection-panel.component.ngfactory.ts